import { format, getDaysInMonth, setDate, setMonth, setYear } from 'date-fns';
import { range } from 'lodash';
import React, { useState } from 'react';
import { Option, Options, Select, Selected } from '.';

interface DateSelect {
  className?: string;
  selectedDate: Date;
  setSelectedDate: (value: Date) => void;
}

const DateSelect: React.FC<DateSelect> = ({ selectedDate, setSelectedDate }) => {
  const [isMonthOpen, setIsMonthOpen] = useState(false);
  const [isDayOpen, setIsDayOpen] = useState(false);
  const [isYearOpen, setIsYearOpen] = useState(false);

  const months = range(0, 12);
  const days = getDaysInMonth(selectedDate);

  function _setSelectedDate(value: any) {
    setSelectedDate(value);
    setIsMonthOpen(false);
    setIsDayOpen(false);
    setIsYearOpen(false);
  }

  return (
    <div className="flex-l justify-center w-100">
      {/* Month */}
      <div className="pl2 pl0-l pr2 flex-auto">
        <Select>
          <Selected onClick={() => setIsMonthOpen(!isMonthOpen)} data-testid="month-select">
            {format(selectedDate, 'MMMM')}
          </Selected>
          {isMonthOpen && (
            <Options onClickOutside={() => setIsMonthOpen(false)} openDirection="UP">
              {months.map((month: number) => (
                <Option
                  key={`month-${month}`}
                  data-testid={`month-${month}`}
                  onClick={() => _setSelectedDate(setMonth(selectedDate, month))}
                  selected={format(selectedDate, 'M') === String(month + 1)}
                >
                  {format(setMonth(selectedDate, month), 'MMMM')}
                </Option>
              ))}
            </Options>
          )}
        </Select>
      </div>

      {/* Day */}
      <div className="ph2 flex-none">
        <Select>
          <Selected onClick={() => setIsDayOpen(!isDayOpen)} data-testid="day-select">
            {format(selectedDate, 'D')}
          </Selected>
          {isDayOpen && (
            <Options onClickOutside={() => setIsDayOpen(false)} openDirection="UP">
              {range(1, days + 1).map((day: number) => (
                <Option
                  key={`day-${day}`}
                  data-testid={`day-${day}`}
                  onClick={() => _setSelectedDate(setDate(selectedDate, day))}
                  selected={format(selectedDate, 'D') === String(day)}
                >
                  {day}
                </Option>
              ))}
            </Options>
          )}
        </Select>
      </div>

      {/* Year */}
      <div className="pl2 pr2 pr0-l">
        <Select>
          <Selected onClick={() => setIsYearOpen(!isYearOpen)} data-testid="year-select">
            {format(selectedDate, 'YYYY')}
          </Selected>
          {isYearOpen && (
            <Options onClickOutside={() => setIsYearOpen(false)} openDirection="UP">
              {range(2019, 2019 - 5).map((year: number) => (
                <Option
                  key={`year-${year}`}
                  data-testid={`year-${year}`}
                  onClick={() => _setSelectedDate(setYear(selectedDate, year))}
                  selected={format(selectedDate, 'YYYY') === String(year)}
                >
                  {year}
                </Option>
              ))}
            </Options>
          )}
        </Select>
      </div>
    </div>
  );
};

export default DateSelect;
